import { requestData } from '../utils/request';
import { recordApi } from '../constant/Config'

//根据roomid 获取课程信息https://record.olacio.com/open-api/sessions/155555 or https://record.olacio.com/open-api/vip-sessions/155555
export const getSessionInfo = async (roomId) => {

    if (!roomId) {
        return null;
    }

    const type = roomId?.split("-")[0] || "0";

    const sessionId = roomId?.split("-")[1];

    let sessions = "sessions"
    if (type === "1") {
        sessions = "vip-sessions"
    }

    const result = await requestData(recordApi + `/open-api/${sessions}/${sessionId}`);
    const data = result.data;

    if (data?.returncode === "SUCCESS") {
        return data?.data;
    } else {
        throw new Error(data?.message);
    }
}

//获取老师信息: https://record.olacio.com/open-recordApi/teachers/197/info
export const getTeacherInfo = async (teacherId) => {

    if (!teacherId) {
        return null;
    }

    const result = await requestData(recordApi + `/open-api/teachers/${teacherId}/info`);
    const data = result.data;

    if (data?.returncode === "SUCCESS") {
        return data?.data;
    } else {
        return null;
    }
}